import TemplateView from "../TemplateView"
import {connect} from '../redux/utils'
import {getLicenseCountDaysToExpiration, isShowLicenseCountDownTip} from './selectors'
import messageResource from '../messageResource'
import {daysNameLower} from '../util/pluralizeUtils'

class LicenseCountDownTip extends TemplateView {
    constructor() {
        super()

        this.state = {
            isShowLicenseCountDownTip: false,
            licenseCountDaysToExpiration: 0,
        }

        this.onAnyStatePropertyDeeplyChanged(['isShowLicenseCountDownTip', 'licenseCountDaysToExpiration'], () => {
            this.$count.text(this.state.licenseCountDaysToExpiration)
            this.$daysLeftText.text(messageResource.getMessage(
                'licenses.count_dawn_tip.days_left',
                [daysNameLower(this.state.licenseCountDaysToExpiration)]
            ))
            this.getEl().toggle(this.state.isShowLicenseCountDownTip)
        })
    }

    templateHtml() {
        return `<div class="licenseCountDownTip">
                    <div class="count"/>
                    <div class="daysLeftText"/>
                    <div class="getLicensesButton"><span><%=buttonText%></span></div>
                </div>`
    }

    messageKeys() {
        return  {
            buttonText: 'licenses.count_dawn_tip.button_text',
        }
    }

    afterRender() {
        this.$count = this.find('.count')
        this.$daysLeftText = this.find('.daysLeftText')

        this.getEl().click(() => window.location= window.BASE_PATH + 'administration/manage_licenses.do')

        this.renderInitialState()
    }
}

export default connect(
    state => ({
        isShowLicenseCountDownTip: isShowLicenseCountDownTip(state),
        licenseCountDaysToExpiration: getLicenseCountDaysToExpiration(state),
    }),
)(LicenseCountDownTip)


// WEBPACK FOOTER //
// ./web/js/activeLicenseInfo/LicenseCountDownTip.js